





















import Vue from "vue";
import { Component,  Prop, Watch } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";

@Component
export default class TechReports extends Vue {
    
}
